export const PUBLIC_ROUTE_PATHS = [
  '/',
  '/help',
  '/legal',
  '/security',
  '/feature-request',
  '/auth/callback',
  '/auth/reset-password',
  '/forgot-password',
  '/help/getting-started',
  '/help/importing-trades',
  '/help/broker-support',
  '/help/replay-and-review',
  '/help/billing-and-trial',
  '/help/account-settings',
  '/login',
  '/signup',
  '/beta',
  '/demo',
] as const;

export type PublicRoutePath = (typeof PUBLIC_ROUTE_PATHS)[number];

export type PublicHelpTopicPath = Extract<
  PublicRoutePath,
  | '/help/getting-started'
  | '/help/importing-trades'
  | '/help/broker-support'
  | '/help/replay-and-review'
  | '/help/billing-and-trial'
  | '/help/account-settings'
>;

const PUBLIC_ROUTE_SET = new Set<string>(PUBLIC_ROUTE_PATHS);
const PUBLIC_ROUTE_ALIASES: Record<string, '/legal'> = {
  '/terms': '/legal',
  '/terms-of-service': '/legal',
  '/privacy': '/legal',
  '/privacy-policy': '/legal',
};

export const PUBLIC_HELP_ROUTES: PublicHelpTopicPath[] = [
  '/help/getting-started',
  '/help/importing-trades',
  '/help/broker-support',
  '/help/replay-and-review',
  '/help/billing-and-trial',
  '/help/account-settings',
];

export const normalizePublicPath = (pathname: string): PublicRoutePath | null => {
  const normalized = String(pathname || '/').trim() || '/';
  const trimmed = normalized.length > 1 ? normalized.replace(/\/+$/, '') : normalized;
  const canonical = PUBLIC_ROUTE_ALIASES[trimmed] || trimmed;
  return PUBLIC_ROUTE_SET.has(canonical) ? (canonical as PublicRoutePath) : null;
};

export const isPublicShellRoutePath = (pathname: string): boolean => {
  const normalized = normalizePublicPath(pathname);
  return Boolean(normalized && normalized !== '/' && normalized !== '/login' && normalized !== '/signup');
};

export const isPublicRoutePath = (pathname: string): pathname is PublicRoutePath => normalizePublicPath(pathname) !== null;

export const isHelpRoutePath = (pathname: string): pathname is '/help' | PublicHelpTopicPath => {
  const normalized = normalizePublicPath(pathname);
  return normalized === '/help' || PUBLIC_HELP_ROUTES.includes(normalized as PublicHelpTopicPath);
};
